/**
 * 파일명: privacyCollect.en.js
 * 설명: 개인정보 수집 및 이용 동의문 (영문)
 *
 * 주의: 법적 효력의 기준은 한국어 원문(privacyCollect.ko.js)이며 본 영문본은 이해를 돕기 위한 참고 번역입니다.
 */
const privacyCollectEn = {
  title: "Consent to the Collection and Use of Personal Information",
  notice:
    "This English version is provided for reference only. In the event of any discrepancy, the Korean original shall prevail.",
  intro: [
    {
      type: "p",
      text: "RIV Technology Co., Ltd. (the “Company”) collects and uses personal information as set out below in order to register you as a member of all Place and to provide the Services. Please review the following before deciding whether to consent.",
    },
  ],
  sections: [
    {
      title: "1. Personal information collected",
      blocks: [
        { type: "p", text: "[Required] Information entered at sign-up" },
        {
          type: "ul",
          items: ["E-mail address", "Company name", "User name", "Password"],
        },
        {
          type: "p",
          text: "Information generated and collected automatically in the course of using the Services, such as access records and cookies, is described in the Privacy Policy.",
        },
      ],
    },
    {
      title: "2. Purposes of collection and use",
      blocks: [
        {
          type: "ul",
          items: [
            "Verifying intent to register, identifying members, and confirming identity",
            "Providing and operating the Services, including meeting room reservations, hot-desking, and video conferencing",
            "Managing access rights at the level of the member's company and processing administrator approvals",
            "Responding to customer inquiries and delivering service notices",
            "Preventing misuse and analyzing service usage statistics",
          ],
        },
      ],
    },
    {
      title: "3. Retention and use period",
      blocks: [
        {
          type: "p",
          text: "Personal information is retained and used until you withdraw your membership or the purposes of collection and use above have been achieved, after which it is destroyed without delay. Where a retention obligation exists under relevant statutes, the information is kept for the period prescribed by those statutes.",
        },
        {
          type: "ul",
          items: [
            "Records concerning consumer complaints or dispute handling: 3 years (Act on the Consumer Protection in Electronic Commerce)",
            "Records concerning payment and the supply of goods: 5 years (Act on the Consumer Protection in Electronic Commerce)",
            "Records concerning contracts or withdrawal of subscription: 5 years (Act on the Consumer Protection in Electronic Commerce)",
            "Records concerning labeling and advertising: 6 months (Act on the Consumer Protection in Electronic Commerce)",
          ],
        },
      ],
    },
    {
      title: "4. Right to refuse consent and consequences of refusal",
      blocks: [
        {
          type: "p",
          text: "You have the right to refuse consent to the collection and use of your personal information. However, the items above are the minimum information necessary for membership registration and provision of the Services, so registration cannot be completed if you refuse.",
        },
      ],
    },
    {
      title: "5. Other matters",
      blocks: [
        {
          type: "p",
          text: "Details of personal information processing — including provision to third parties, destruction procedures, and how to exercise your rights as a data subject — are set out in the Privacy Policy.",
        },
      ],
    },
  ],
};

export default privacyCollectEn;
